export default class Constraints {

    static BY_ITEM = 1

    static CHILDREN_ONLY = 2

}